import * as graph from "@microsoft/microsoft-graph-client";

function getAuthenticatedClient(accessToken: string) {
  // Initialize Graph client
  const client = graph.Client.init({
    // Use the provided access token to authenticate
    // requests
    authProvider: (done: (error: unknown, accessToken: string | null) => void) => {
      done(null, accessToken);
    },
  });

  return client;
}

export async function getUserDetails(accessToken: string) {
  const client = getAuthenticatedClient(accessToken);

  const user = await client
    .api("/me")
    //.select("displayName,mail,mailboxSettings,userPrincipalName")
    .get();

  return user;
}

// https://graph.microsoft.com/v1.0/me/transitiveMemberOf/microsoft.graph.group?$count=true

export async function getUserGroups(accessToken: string) {
  const client = getAuthenticatedClient(accessToken);

  // Search for groups user is a member of containing the string "Administrator"
  const user_groups = await client
    .api(
      '/me/memberOf/microsoft.graph.group?$orderby=displayName&$search="displayName:Administrator"&$select=displayName,id'
    )
    .headers({ ConsistencyLevel: "eventual" })
    .get();

  return user_groups;
}
